import React from 'react';
import { Box } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import SceneContextFactsCard from 'app/components/ScenarioEditorPage/ScenarioSettings/SceneContextFactsCard.tsx';
import type { ScenarioSettingsType } from 'app/components/ScenarioEditorPage/ScenarioSettings/hooks/useScenarioForm.ts';
import ScenarioContextLocationsCard from 'app/components/ScenarioEditorPage/ScenarioSettings/SceneContextLocationsCard.tsx';

type ScenarioContextSettings = {
  scenarioId?: number;
};

const ScenarioContextSettings: React.FunctionComponent<ScenarioContextSettings> = ({ scenarioId }) => {
  const { control } = useFormContext<ScenarioSettingsType>();

  return (
    <Box>
      <Controller
        control={control}
        name={`context.id` as const}
        render={({ field: inputField }) => <input type="hidden" {...inputField} />}
      />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>
        <SceneContextFactsCard />
        <ScenarioContextLocationsCard />
      </Box>
    </Box>
  );
};

export default ScenarioContextSettings;
